// extracted by css-extract-rspack-plugin
export default {"attachButton":"ImageAttachButton-module__attachButton__iF3pZ"};